import {computed} from 'vue';
import {useStore} from 'vuex';
import getSymbolFromCurrency from 'currency-map-symbol';

export const stringToHslColor = (str, s, l) => {
  let hash = 0;
  /* eslint-disable */
  const string = str ? str : '';
  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  /* eslint-enable */
  const h = hash % 360;
  return `hsl(${h}, ${s}%, ${l}%)`;
};

// Keyed on the raw bank name, as in "Mes banques", so renaming a connection keeps its color.
export const resolveBankLogoColor = (name, banks, accountsByCompany) => {
  const bank =
    name &&
    (banks || []).find((b) => b.custom_name === name || b.name === name);
  const account =
    name &&
    !bank &&
    Object.values(accountsByCompany || {})
      .flat()
      .find((a) => a.bank_custom_name === name || a.bank_name === name);
  return stringToHslColor(bank?.name || account?.bank_name || name, 50, 60);
};

export function useCurrencyFormatter() {
  const store = useStore();

  const defaultCurrency = computed(() => store.state.user.defaultCurrency);
  const locale = computed(() => store.getters['user/getLocaleIso']);
  const bankLogoColor = (name) =>
    resolveBankLogoColor(
      name,
      store.state.bank.banks,
      store.state.bank.accountsByCompany,
    );
  const nameToSlug = (name, count = 3) => {
    const wordArray = name.split(' ');
    let slug = '';
    if (wordArray.length === 1) {
      slug = wordArray[0].slice(0, 2);
    } else if (wordArray.length === 2) {
      slug = wordArray[0].slice(0, 1);
      slug += wordArray[1][0];
    } else {
      wordArray.forEach((word) => {
        if (slug.length < count) {
          slug += word[0];
        }
      });
    }
    return slug;
  };

  const formatCurrency = (
    value,
    {
      currency = defaultCurrency.value,
      minimumFractionDigits = 0,
      maximumFractionDigits = 0,
      notation = 'standard',
      compactDisplay = 'long',
    } = {},
  ) =>
    new Intl.NumberFormat(locale.value, {
      style: 'currency',
      currency,
      minimumFractionDigits,
      maximumFractionDigits,
      notation,
      compactDisplay,
    }).format(value);

  const formatCurrencyWithDecimal = (val, cur) =>
    formatCurrency(val, {
      currency: cur || defaultCurrency.value,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return {
    defaultCurrency,
    locale,
    getSymbolFromCurrency,
    formatCurrency,
    nameToSlug,
    stringToHslColor,
    bankLogoColor,
    formatCurrencyWithDecimal,
  };
}
